/**
 * Removes anything that is not a word character, dash or period from a string.
 * Word characters, `\w`, are equivalent in regex to: [a-zA-Z0-9_]
 * @param {string} input
 */
export const removeSpecialCharacters = (input: string): string =>
    input.replace(/[^\w-.]/gi, '');
